import { createContext, useContext, useLayoutEffect, type Dispatch, type SetStateAction } from 'react';

export const ComposerDockFocusContext = createContext<Dispatch<SetStateAction<boolean>> | null>(null);

/** Reports add-mode focus to the nearest dock and says whether one owns this composer. */
export const useComposerDockFocus = (focused: boolean) => {
	const setDockFocused = useContext(ComposerDockFocusContext);
	useLayoutEffect(() => {
		if (!setDockFocused) return;
		setDockFocused(focused);
		return () => setDockFocused(false);
	}, [focused, setDockFocused]);
	return setDockFocused !== null;
};
